<template>
  <w-dialog
    :show="visible"
    @close="handleClose"
    class="ent-binding-account"
    :title="account ? '使用预选账号' : '绑定已有账号'"
    :wallStyle="{ zIndex: 2001 }"
    :box-style="{ width: '500px', zIndex: 2001 }"
    :bodyStyle="{ padding: '20px 24px 24px 24px' }"
    :footerStyle="{ padding: '24px', borderTop: 'none' }">
    <div>
      <div class="ent-explain-text" v-show="account">
        请输入本账号登录密码，进行二次验证
      </div>
      <div class="ent-binding-form">
        <w-form ref="ruleForm" :model="ruleForm" label-width="60px" :rules="account ? rules : {
                      account: [{required: true, message: '账号不能为空', trigger: 'blur'}],
                      password: rules.password
                     }" label-position="right">
          <w-form-item label="账号" prop="account" style="margin-bottom: 24px;">
            <w-input size="small" readonly disabled :value="account" placeholder="请输入账号" v-if="account"></w-input>
            <w-input size="small" v-model="ruleForm.account" placeholder="请输入账号 " v-else></w-input>
          </w-form-item>
          <w-form-item label="密码" prop="password" style="margin-bottom: 0;">
            <w-input size="small" v-model="ruleForm.password" placeholder="请输入密码"></w-input>
          </w-form-item>
        </w-form>
      </div>
    </div>
    <div slot="footer" class="text-align-right">
      <w-button size="small" type="minor" @click="handlePrevious()">上一步</w-button>
      <w-button size="small" type="primary" @click="handleSubmit()">确定</w-button>
    </div>
  </w-dialog>
</template>

<script>
export default {
  name: 'BindingAccount',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    account: String
  },
  data () {
    return {
      ruleForm: {
        account: '',
        password: ''
      },
      rules: {
        password: [{required: true, message: '密码不能为空', trigger: 'blur'}]
      }
    }
  },
  watch: {
    visible: {
      handler () {
        this.$nextTick(() => {
          this.$refs.ruleForm && this.$refs.ruleForm.clearValidate()
        })
      }
    },
    account: {
      handler (value) {
        value && Object.assign(this.ruleForm, {
          account: value
        })
      },
      immediate: true
    }
  },
  methods: {
    // 上一步
    handlePrevious () {
      this.$refs.ruleForm.resetFields()
      this.$emit('previous')
    },
    // 取消
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.$emit('close')
    },
    // 提交
    handleSubmit () {
      this.sentLog(100117109)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.bindingAccount()
        }
      })
    },
    // 绑定请求
    bindingAccount () {
      // API
      this.$emit('success', this.ruleForm)
      // 1. 验证账号密码正确性
      // 2. 验证是否当前企业账号
      // 3. 验证账号是否未绑定手机号
    }
  }
}
</script>
